import React from "react";

export const Circle = ({ size, color, borderWidth, borderColor }) => {
  return (
    <g>
      <circle
        r={size / 2}
        fill={color}
        stroke={borderColor}
        strokeWidth={borderWidth}
        style={{ pointerEvents: 'none' }}
      />
    </g>
  );
};
